/**
 * Theme Manager — Charte ASLANE unifiée (Module 3)
 * Applique le thème selon le rôle utilisateur.
 */

export function applyTheme() {
  const userStr = localStorage.getItem('user');
  const viewAsTechnician = localStorage.getItem('viewAsTechnician') === 'true';

  if (!userStr) {
    document.body.setAttribute('data-role', 'TECHNICIAN');
    document.body.setAttribute('data-theme', 'technician');
    document.documentElement.setAttribute('data-theme', 'technician');
    document.getElementById('splash')?.setAttribute('data-theme', 'technician');
    return;
  }

  try {
    const user = JSON.parse(userStr);
    const realRole = (user.role || 'TECHNICIAN').toUpperCase();
    const effectiveRole = (viewAsTechnician && realRole === 'ADMIN') ? 'TECHNICIAN' : realRole;
    const themeForRole = effectiveRole === 'TECHNICIAN' ? 'technician' : 'admin';

    document.body.setAttribute('data-role', realRole);
    document.body.setAttribute('data-theme', themeForRole);
    document.documentElement.setAttribute('data-theme', themeForRole);
    document.getElementById('splash')?.setAttribute('data-theme', themeForRole);

    console.log(`✅ Thème ASLANE appliqué : ${themeForRole} (role=${realRole}${viewAsTechnician ? ', vue technicien' : ''})`);
  } catch (error) {
    console.error('Erreur application thème:', error);
    document.body.setAttribute('data-role', 'TECHNICIAN');
    document.body.setAttribute('data-theme', 'technician');
    document.documentElement.setAttribute('data-theme', 'technician');
  }
}

applyTheme();

window.addEventListener('storage', (e) => {
  if (e.key === 'user' || e.key === 'viewAsTechnician') {
    applyTheme();
  }
});

window.addEventListener('themechange', applyTheme);

window.applyTheme = applyTheme;
